<template>
  <div class="loader-overlay" v-if="isLoading">
    <div class="custom-loader"></div>
  </div>
</template>

<script>
import store from "../vuex/store";

export default {
  computed: {
    isLoading() {
      return store.getters.isLoading;
    },
  },
};
</script>

<style>
.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.custom-loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #ffb800;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Анімація для появи та зникнення прелоадера */
.loader-overlay-enter-active,
.loader-overlay-leave-active {
  transition: opacity 0.5s;
}

.loader-overlay-enter,
.loader-overlay-leave-to {
  opacity: 0;
}
</style>
